module.exports = __webpack_public_path__ + "static/Short3-e253ca137cb9857230e6d5046c6da544.png";